<script lang="ts">
  import { get,  writable } from "svelte/store";
  import ContactDropdown from "../../components/Business/ContactDropdown.svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import DateInput from "../../components/Form/Fields/DateInput.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import InvoiceDashboard from "../../components/Business/InvoiceDashboard.svelte";
  import Table from "../../components/Table/Table.svelte";
  import SelectableTable from "../../components/Table/SelectableTable.svelte";  
  import type { ICompanyInvoice } from "../../entities";
  import type { ICompanyInvoiceDTO, ICompanyInvoiceEmailDTO } from "../../services/DTO";
  import CustomFields from "../../components/CustomFields/CustomFields.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { companyInvoiceEmailsDtoFields } from "../../utils/TableFields/company-invoice-emails-dto.fields";
  import OwnershipDropdown from "../../components/Form/Fields/Dropdown/OwnershipDropdown.svelte";
  import {setNull} from "../../utils/object-utils";
  import { PermissionService } from "../../utils/misc/permission-utils";
  import { companyInvoicePaymentDtoFields } from "../../utils/TableFields/company-invoice-payment-dto.fields";
  import { companyInvoicePaymentEmailsDtoFields } from "../../utils/TableFields/company-invoice-payment-emails-dto.fields";
import UnpaidStatesMultiSelect from "../../components/Business/UnpaidStatesMultiSelect.svelte";
import ConfirmModal from "../../components/Modal/ConfirmModal.svelte";

    import { user } from "../../app.store";
  import {
    loading,
    loading_invoicesemails,
    loadWithUpdate,
    records,
    record,
    search,
    filter,
    initList,
    save,
    resetSearchFilter,
    companyInvoicesEmails,
    pagination_invoicesemails,
    onPageChangeInvoiceEmails,
    filter_invoiceemails,
    searchInvoicesEmails,
    loadInvoicesEmails,
    sendEmails
  } from "./company.unpaidinvoices.store";
    import type { ICompanyInvoicePaymentDTO } from "../../services/DTO/entity/company-invoice-payment-dto";
    import { onMount } from "svelte";
    import UnpaidModal from "../Unpaid/UnpaidModal.svelte";
    import Button from "../../components/Button.svelte";
    import Icon from "../../components/Icon.svelte";
    import type { ICompanyInvoicePaymentEmailDTO } from "../../services/DTO/entity/company-invoice-payment-email-dto";
    import type { ICompanyInvoicePaymentEmailPreviewDTO } from "../../services/DTO/entity/company-invoice-payment-email-preview-dto";

  export let oid: number;
  let cansend : boolean = PermissionService.isAllowedTo($user, 'companyinvoices.cansend');
 
  const editing = writable<boolean>(false);
  const sendModalOpen = writable<boolean>(false);
  const confirmModalOpen = writable<boolean>(false);
  const selected = writable<ICompanyInvoicePaymentDTO[]>([]);
  let targets = [];   
    
  async function onSubmitExisting() {
    await save();
    onCancel();
  }

  function updateSelected(items: ICompanyInvoicePaymentDTO[]){
    targets = [];
    items.forEach(element => {
      if (element.selected)
        targets.push(element);
    });
  }

  function onCancel() {
    editing.set(false);
    record.set({} as ICompanyInvoicePaymentDTO);
  }


  function onSendSingle(item: ICompanyInvoicePaymentDTO) {
    targets = [item]; 
    selected.set(targets);
    sendModalOpen.set(true); 
  }

  function onSendSelected() {
    selected.set(targets);
    sendModalOpen.set(true); 
  }


  function onSendEmails(pec: boolean, results: ICompanyInvoicePaymentEmailPreviewDTO[]){
    sendEmails(oid, pec, results, null);
    editing.set(false);
    sendModalOpen.set(false); 
    record.set({} as ICompanyInvoicePaymentDTO);
  }

  function onCancelEmail(){
    sendModalOpen.set(false); 
  }

  function onEdit(item: ICompanyInvoicePaymentDTO) {
    record.set(Object.assign({}, item));
    editing.set(true);
  }

    const selectedresend = writable<ICompanyInvoicePaymentEmailDTO>();
    
    function onResendemail(dto: ICompanyInvoicePaymentEmailDTO){
      selectedresend.set(dto);
      confirmModalOpen.set(true); 
    }
    
    async function onSendEmail(){
    let s = get(selectedresend);
    await sendEmails(oid, true, null, s.email.oid);
    confirmModalOpen.set(false); 
    searchInvoicesEmails(oid);
    }

    function onCancelConfirm(){
      confirmModalOpen.set(false); 
    }

    function resetSearchInvoicesEmails(){
      setNull($filter_invoiceemails.criteria);
      searchInvoicesEmails(oid);
    }

    onMount(() => initList(oid));
</script>

<UnpaidModal open={$sendModalOpen}
    targets={$selected}
    on:confirm={(e) => onSendEmails(e.detail.pec, e.detail.results)}
    on:decline={(e) => onCancelEmail()}
    />
  
    <SearchHeader
      entitySingular="insoluto"
      entityPlural="insoluti"
      numRecords={$records == null? 0 : $records.length}
      bind:searchValue={$filter.criteria.query}
      on:search={() => search(oid)}
      on:reset={() => resetSearchFilter(oid)}
      clearButtonVisible={false}
      searchFieldVisible={false}
    >
    <div slot="search">      
      <div  class="level">
        <div class="level-item">
          <div  class="level-item">
            <FormField>
              <DateInput
                name=""
                placeholder="Data Inizio"
                required={false}
                allowInput={true}
                bind:value={$filter.criteria.dataScadenzaFrom}
                  on:dateChanged={(e) => search(oid)}
              />
            </FormField>
            </div>
            <div class="level-item">
            <FormField>
              <DateInput
                name=""
                placeholder="Data Fine"
                required={false}
                allowInput={true}
                bind:value={$filter.criteria.dataScadenzaTo}
                  on:dateChanged={(e) => search(oid)}
              />
            </FormField>
          </div> 
          
          <div class="level-item">
            <p class="control">
              <Button on:click={(e) => search(oid)}>
                <Icon name="search" />
      
                <span> Cerca </span>
              </Button>
            </p>
          </div>


          <div class="level-item">
            <p class="control">
              <Button on:click={(e) => loadWithUpdate(oid)}>Aggiorna e ricarica</Button>
            </p>
          </div>
      
          <div class="level-item">
            <p class="control">
              <Button on:click={(e) => resetSearchFilter(oid)}>Azzera</Button>
            </p>
          </div>
  
          {#if cansend === true}
          <div class="level-item">
            <p class="control">
              <Button on:click={(e) => onSendSelected()}>Invia a selezionati</Button>
            </p>
          </div>
          {/if}
          
        </div>
      </div>
      <div  class="level">
        <div class="level-item" >
          <div class="level-item">
            <FormField usageHelp="Stati">            
             <UnpaidStatesMultiSelect
             bind:value={$filter.criteria.stati}
             />
            </FormField>
          </div>
        </div>
     
      </div> 
    </div>
    </SearchHeader>

    <SelectableTable
    loading={$loading}
    fields={companyInvoicePaymentDtoFields}
    records={$records}
    pagination={null}
    createEnabled={false}
    showEnabled={cansend}
    deleteEnabled={false}
    downloadEnabled={false}
    customEnabled={cansend}
    customIcon="send"
    on:allupdate={(e) => updateSelected(e.detail)}
    on:custom={(e) => onSendSingle(e.detail)}
    on:edit={(e) => onEdit(e.detail)}
  />
  

  <ConfirmModal open={$confirmModalOpen}
  title="Conferma re-invio"
  message="Inviare nuovamente la mail/pec?"
  on:confirm={(e) => onSendEmail()}
  on:decline={(e) => onCancelConfirm()}
  />
  
      <SearchHeader
        entitySingular="sollecito inviato"
        entityPlural="solleciti inviati"
        numRecords={$pagination_invoicesemails != null ? $pagination_invoicesemails.totalRecords : 0}
        bind:searchValue={$filter_invoiceemails.criteria.query}
        on:search={() => searchInvoicesEmails(oid)}
        on:reset={() => resetSearchInvoicesEmails()}      
        searchFieldVisible={false}
        clearButtonVisible={false}
      >
  
    <div slot="search" class="level">
      <div class="level-item" >
        <div>
          <FormField>
            <DateInput
              name=""
              placeholder="Data Inizio"
              required={false}
              bind:value={$filter_invoiceemails.criteria.dataFrom}
                on:dateChanged={() => searchInvoicesEmails(oid)}
            />
          </FormField>           
        </div>
      </div>
  
  
      <div class="level-item" >
        <div>
          <FormField>
            <DateInput
              name=""
              placeholder="Data Fine"
              required={false}
              bind:value={$filter_invoiceemails.criteria.dataTo}
                on:dateChanged={() => searchInvoicesEmails(oid)}
            />
          </FormField>          
        </div>
      </div>
      <div class="level-item" >
        <div>
          <FormField usageHelp="Visualizza solo invii falliti">
            <Switch
              name=""
              condensed={true}
              altText="Solo invii falliti"
              bind:value={$filter_invoiceemails.criteria.falliti}
              on:toggle={() => searchInvoicesEmails(oid)}
            />
          </FormField>
        </div>
      </div>
    
      <div class="level-item">
        <p class="control">
          <Button on:click={() => searchInvoicesEmails(oid)}>
            <Icon name="search" />
  
            <span> Cerca </span>
          </Button>
        </p>
      </div>
  
      <div class="level-item">
        <p class="control">
          <Button on:click={resetSearchInvoicesEmails}>Azzera</Button>
        </p>
      </div>
    </div>
  
    </SearchHeader>
  

  <Table
    loading={$loading_invoicesemails}
    fields={companyInvoicePaymentEmailsDtoFields}
    records={$companyInvoicesEmails}
    pagination={$pagination_invoicesemails}
    createEnabled={false}
    editEnabled={false}
    customEnabled={cansend}
    customIcon="send"
    deleteEnabled={false}
    downloadEnabled={false}
    on:custom={(e) => onResendemail(e.detail)}
    on:pageChange={(e) => onPageChangeInvoiceEmails(oid, e.detail)}
  />
 